export enum ADDITIONAL_DETAILS {
  ASSEMBLY_NUMBER = 'assemblyNumber',
  CONTROL_NUMBER = 'controlNumber',
  CHEMISTRY_MARKET_NAME = 'chemistryMarketName',
  CHEMICAL_NAME_OR_MATERIAL = 'chemicalNameorMaterial',
  MOLECULAR_FORMULA = 'molecularFormula',
  SOURCED = 'sourced',
  PRODUCTION_DATE = 'productionDate',
  LITHIUM_PRODUCER = 'lithiumProducer',
  COBALT_PRODUCER = 'cobaltProducer',
  CHEMICAL_COMPOSITION = 'chemicalComposition',
  ELECTROCHEMICAL_PERFORMANCE = 'electrochemicalPerformance',
  DETAILS = 'details',
  PRODUCER = 'producer',
  SIZE_CALCULATION = 'sizeCalculation',
  PHYSICAL_PROPERTIES = 'physicalProperties',
  PARTICLE_SIZE_DISTRIBUTION = 'particleSizeDistribution',
  RECIPIENT = 'recipient',
  ISSUER = 'issuer',
  DEALER = 'dealer',
  CHEMISTRY_BATCH_NUMBER = 'chemistryBatchNumber',
  TEST_DATE = 'testDate',
  CHEMICAL_COMPOSITION_TEST_RESULTS = 'chemicalCompositionTestResults',
  PARTICLE_SIZE_DISTRIBUTION_TEST_RESULTS = 'particleSizeDistributionTestResults',
  PHYSICAL_PROPERTIES_TEST_RESULTS = 'physicalPropertiesTestResults',
  TEST_RESULTS = 'testResults',
  SHIPPING_DATE = 'shippingDate',
  RECEIVING_DATE = 'receivingDate',
}

export enum PRODUCER_DETAILS {
  NO = 'no',
  COMPANY = 'company',
  COMPANY_FULL_NAME = 'companyFullName',
  COMPANY_HEADQUATERS = 'companyHeadquaters',
  MINE = 'mine',
  FACTORY_LOCATION = 'factoryLocation',
  COORDINATES = 'coordinates',
  CHILD_LABOR_SCORING = 'childLaborScoring(6Max,1Min)',
  HUMAN_RIGHTS_SCORING = 'humanRightsScoring(6max,1Min)',
  ESG_SCORING = 'esgScoring(6max,1Min)',
  RECYCLER_LOCATION = 'recyclerLocation',
}

export enum CHEMICAL_COMPOSITION_DETAILS {
  LI = 'Li (wt%)',
  NA = 'Na (wt%)',
  FE = 'Fe (wt%)',
  CU = 'Cu (wt%)',
  H2O = 'H2O (wt%)',
  Li2C03 = 'Li2C03 (wt%)',
  NI = 'Ni (mol%)',
  MN = 'Mn (mol%)',
  CO = 'Co (mol%)',
  CA = 'Ca (wt%)',
  P = 'P (wt%)',
  PB = 'Pb (wt%)',
  C = 'C ( wt%)',
}

export enum CHEMICAL_COMPOSITION_TEST_RESULTS_DETAILS {
  NiMnCo = 'NiMnCo (wt%)',
  LI = 'Li (wt%)',
  NA = 'Na (wt%)',
  FE = 'Fe (wt%)',
  CU = 'Cu (wt%)',
  H2O = 'H2O (wt%)',
  Li2C03 = 'Li2C03 (wt%)',
  NI = 'Ni (mol%)',
  MN = 'Mn (mol%)',
  CO = 'Co (mol%)',
  CA = 'Ca (wt%)',
  P = 'P (wt%)',
  PB = 'Pb (wt%)',
  C = 'C ( wt%)',
}

export enum PHYSICAL_PROPERTIES_DETAILS {
  BET = 'BET (m2/g)',
  TAP_DENSITY = 'Tap Density (g/cm3)',
  PH = 'pH',
}

export enum PARTICLE_SIZE_DISTRIBUTION_DETAILS {
  D10 = 'd10',
  D50 = 'd50',
  D90 = 'd90',
}

export enum SIZE_CALCULATION_DETAILS {
  ORDERS = 'orders',
  MANUALS = 'manuals',
  CAR_MANUAL = 'carManual',
  DESCRIPTION_OF_RECYCLING = 'descriptionOfRecycling',
}

export enum TEST_RESULTS_DETAILS {
  NOMINAL_CAPACITY = 'nominalCapacity',
  AVERAGE_NOMINAL_CAPACITY = 'averageNominalCapacity',
  NOMINAL_VOLTAGE = 'nominalVoltage',
  VOLTAGE = 'voltage(maxCharge)',
  ENERGY = 'energy',
  HEALTH_TEST = 'healthTest',
  TOTAL_CAPACITY = 'totalCapacity',
  USABLE_CAPACITY = 'usableCapacity',
  WEIGHT = 'weight',
  GRAVIMETRIC_ENERGY_DENSITY = 'gravimetricEnergyDensity',
}

export enum DEALER_DETAILS {
  NAME = 'name',
  ADRESS = 'address',
  COUNTRY = 'country',
  COORDINATES = 'coordinates',
}

export enum NESTED_DETAILS {
  CHEMISTRY = 'chemistry',
  CHEMISTRY_BATCH_NUMBER = 'chemistryBatchNumber',
  TECHNICAL_SPEC = 'technicalSpec',
  CERTIFICATES_OF_CONFORMITY = 'certificatesOfConformity',
  TARIC_CODE = 'taricCode',
  BATTERY_PRODUCERS = 'batteryProducers',
  BATTERY_CELL_MODEL = 'batteryCellModel',
  BATTERY_CELL_GLOBAL_TRADE_IDENTIFICATION_NUMBER = 'batteryCellGlobalTradeIdentificationNumber',
  BATTERY_CELL_PRODUCTION_DATE = 'batteryCellProductionDate',
  BATTERY_CELL_CHILD_LABOR_SCORING = 'batteryCellChildLaborScoring',
  BATTERY_CELLS_HUMAN_RIGHTS_AVERAGE = 'batteryCellsHumanRightsAverage',
  BATTERY_CELLS_CHILD_LABOR_AVERAGE = 'batteryCellsChildLaborAverage',
  BATTERY_CELL_PRODUCER_ESG_SCORING = 'batteryCellProducerEsgScoring',
  BATTERY_PRODUCTION_DATE = 'batteryProductionDate',
  BATTERY_PACKS_GLOBAL_TRADE_IDENTIFICATION_NUMBER = 'batteryPacksGlobalTradeIdentificationNumber',
  BATTERY_PACKS_RECYCLING = 'batteryPacksRecycling',
  BATTERY_CELLS_BATCH_NUMBER = 'batteryCellsBatchNumber',
  BATTERY_PACK_CHILD_LABOR_AVERAGE = 'batteryPackChildLaborAverage',
  BATTERY_PACK_HUMAN_RIGHTS_AVERAGE = 'batteryPackHumanRightsAverage',
  BATTERY_PACK_ESG_SCORING_AVERAGE = 'batteryPackEsgScoringAverage(6max,1Min)',
  BATTERY_PACK_SERIAL_NUMBER = 'batteryPackSerialNumber',
  MATERIALS_CHILD_LABOR_AVERAGE = 'materialsChildLaborAverage',
  MATERIALS_HUMAN_RIGHTS_AVERAGE = 'materialsHumanRightsAverage',
  WEIGHT = 'weight',
  GRAVIMETRIC_ENERGY_DENSITY_CLEAN = 'gravimetricEnergyDensity',
  GRAVIMETRIC_ENERGY_DENSITY = 'gravimetricEnergyDensity:', // HACK for backend data
  INTERNAL_RESISTANCE = 'internalResistance',
  NOMINAL_CAPACITY = 'nominalCapacity',
  AVERAGE_NOMINAL_CAPACITY = 'averageNominalCapacity',
  VOLTAGE = 'voltage(maxCharge)',
  NOMINAL_VOLTAGE = 'nominalVoltage',
  ENERGY = 'energy',
  FORMAT = 'format:', // HACK for backend data
  CHARGING_METHOD = 'chargingMethod',
  CHARGING_CURRENT = 'chargingCurrent',
  CHARGING_TIME = 'chargingTime',
  CHARGING_CYCLES = 'chargingCycles',
  DISCHARGE_POWER = 'dischargePower',
  EVMODEL = 'eVModel',
  COOLING = 'cooling',
  CELLS_SETUP = 'cellsSetup',
  TOTAL_CAPACITY = 'totalCapacity',
  USABLE_CAPACITY = 'usableCapacity',
  STORAGE_TEMP_RANGE = 'storageTempRange',
  WARRANTY_CONDITIONS = 'warrantyConditions',
  DESCRIPTION = 'description',
  TECHNICAL_REVIEW_STATUS = 'technicalReviewStatus',
  TECHNICAL_REVIEW_DATE = 'technicalReviewDate',
  SALE_DATE = 'saleDate',
  REPAIR_DESCRIPTION = 'repairDescription',
  REPAIR_DATE = 'repairDate',
  HEALTH_DESCRIPTION = 'healthDescription',
  REPURPOSE_DATE = 'repurposeDate',
  REMANUFACTURING_TYPE = 'remanufacturingType',
  RECYCLE_DATA = 'recycleData',
  RECYCLE_PERCENT = 'recyclePercent',
  RECYCLE_MATERIAL = 'recycleMaterial',
  OF_WASTES = '%ofWastes',
  WASTE_WEIGHT = 'wasteWeight(kg)',
}

export type ComponentDetailsModel = {
  componentPassportId?: string;
  supplierId: string;
  supplierName: string;
  componentName: string;
  componentId: string;
  itemId?: string;
  batchNumber: string;
  countryOfOrigin: string;
  region?: string;
  factory?: string;
  percentShare: number;
  percentRecycled: number;
};

export type CertificateNestedProperty<T> = { label: T; value: string };

export type CertificateDetailsModel = {
  certificateName: string;
  productName: string;
  productId: string;
  batchNumber: string;
  company: string;
  itemId?: string;
  title?: string;
  countryOfOrigin: string;
  region?: string;
  factory?: string;
  additionalComments?: string;
  percentRecycled: number;
  components?: ComponentDetailsModel[];
  additionalCertificate?: File;
  assemblyNumber?: string;
  controlNumber?: string;
  chemistryMarketName?: string;
  chemistryBatchNumber?: string;
  productionDate?: string;
  saleDate?: string;
  sourced?: string;
  chemicalNameorMaterial?: string;
  molecularFormula?: string;
  electrochemicalPerformance?: string;
  recipient?: string;
  issuer?: string;
  batteryCellModel?: string;
  batteryCellsBatchNumber?: string;
  testDate?: string;
  shippingDate?: string;
  receivingDate?: string;
  eVModel?: string;
  batteryPackSerialNumber?: string;
  chemicalComposition?: CertificateNestedProperty<CHEMICAL_COMPOSITION_DETAILS>[];
  physicalProperties?: CertificateNestedProperty<PHYSICAL_PROPERTIES_DETAILS>[];
  particleSizeDistribution?: CertificateNestedProperty<PARTICLE_SIZE_DISTRIBUTION_DETAILS>[];
  producer: CertificateNestedProperty<PRODUCER_DETAILS>[];
  lithiumProducer: CertificateNestedProperty<PRODUCER_DETAILS>[];
  cobaltProducer: CertificateNestedProperty<PRODUCER_DETAILS>[];
  details: CertificateNestedProperty<NESTED_DETAILS>[];
  sizeCalculation: CertificateNestedProperty<SIZE_CALCULATION_DETAILS>[];
  chemicalCompositionTestResults: CertificateNestedProperty<CHEMICAL_COMPOSITION_TEST_RESULTS_DETAILS>[];
  physicalPropertiesTestResults: CertificateNestedProperty<PHYSICAL_PROPERTIES_DETAILS>[];
  particleSizeDistributionTestResults: CertificateNestedProperty<PARTICLE_SIZE_DISTRIBUTION_DETAILS>[];
  testResults: CertificateNestedProperty<TEST_RESULTS_DETAILS>[];
  dealer: CertificateNestedProperty<DEALER_DETAILS>[];
};
